module.exports = __webpack_public_path__ + "static/worker-68a60155cf0d1f65ee54bac61be4171e.png";